export const DELETE_DISCOVERY_BOX_MUTATION = `
mutation CartMutation {
  deleteDiscoveryBox {
    data{
      products {
          additionalVariantInfo
          productId
          productCode
          masterId
          masterProductCode
          url
          imageUrl
          brandId
          brandName
          name
          variant
          subName
          annotation
          package
          maxOrderQty
          canBuy
          stockAvailability
          orderUnit
          showWatchdog
          primaryCategories {
            kind
            category
            subCategory
            type
          }
          itemId
          count
          vat
          priceWithVat
          priceSumWithVat
          engraving {
              value
              priceWithVat
              cartServiceItem
              cartItemId
          }
          unitPrice {
            amount
            price
            unit
          }
          isHidden
          action
          autoInserted
          freeProduct
          addedByCoupon
          usedProductInfo {
              volumeInPercent
              descriptions
          }
          upselling
          tryItFirstId
          attributes {
              key
              value
          }
          priceHistory
          discount
          voucherDiscount {
              voucherCode
              discountedPrice
          }
          isLoyalty
          isMedicinal
      }
      serviceItems {
        discoveryBox {
          itemId
          priceWithVat
          allProductsAvailable
          productCode
          brandName
          name
          vat
          priceSumWithVat
          count
          productId
          products {
           imageUrl
            brandName
            name
            annotation
            stockAvailability
            productCode
            vat
            priceWithVat
            count
            variant
            additionalVariantInfo
            productId
            primaryCategories {
              kind
              category
              subCategory
              type
          }
          }
        }
      }
      pricesSummary {
        vat
        priceItemSummary
        pricePayment
        priceDelivery
        priceProductsSummary
        discountWithoutDelivery
      }
    }
    messages
  }
}
`;
